import dishwasherSafeIcon from '@features/pdp/images/dishwasher-safe-icon.svg';
import iceRetentionIcon from '@features/pdp/images/ice-retention-icon.svg';
import { ProductTypeId } from '@types';
import { useSelector } from 'react-redux';
import { MIYO_DISABLED_COLORS } from '../settings';
import cx from '@utils/cx.util';

const iceRetentionCompat = [ProductTypeId.CUB_BOTTLE];

const shownFor = [
  ...iceRetentionCompat,
  ProductTypeId.DOG_BOWL,
  ProductTypeId.CAN_COOLER,
  ProductTypeId.SKINNY_CAN_COOLER,
  ProductTypeId.CRAFT_CAN_COOLER,
];

const DrinkwareSubtitle = () => {
  const { details, canMiyo, variants } = useSelector((state: any) => state.pdpItem);

  if (!details || !shownFor.includes(details.attributes.typeId || -1)) return null;

  const miyoOverride = details?.uom.id === 1;
  const isMiyoable = miyoOverride && canMiyo && !MIYO_DISABLED_COLORS.includes(variants?.activeColor?.id);

  return (
    <div className={cx('tw:mt-6 tw:flex tw:flex-col tw:gap-2')}>
      <Item>
        <img
          src={dishwasherSafeIcon}
          alt='Dishwasher Safe Icon'
          className='tw:h-full tw:max-h-[18px] tw:max-w-full'
        />
        <span>Dishwasher safe</span>
      </Item>
      {iceRetentionCompat.includes(details.attributes.typeId || -1) && (
        <Item>
          <img
            src={iceRetentionIcon}
            alt='Ice Retention Icon'
            className='tw:h-full tw:max-h-[18px] tw:max-w-full'
          />
          <span>Up to 24-hour ice retention</span>
        </Item>
      )}
      <Item>
        {isMiyoable && (
          <>
            <span>Personalize with</span>
            <img
              src='/assets/images/rtic/myRTIC-Logo.png'
              alt='MyRTIC Logo'
              className='tw:h-full tw:max-h-[12px] tw:max-w-full'
            />
          </>
        )}
      </Item>
    </div>
  );
};

const Item = ({ children }) => (
  <p className='tw:mb-0 tw:flex tw:h-[18px] tw:w-full tw:items-center tw:gap-[5px] tw:text-base'>
    {children}
  </p>
);

export default DrinkwareSubtitle;
